import { useContext } from 'react';
import styled from 'styled-components';
import Answer from 'components/Answer';
import { GameContext } from 'contexts/GameContext';
import { List, Item } from 'elements/List';
import { Paragraph } from 'elements/Text';

const Title = styled(Paragraph)(({ theme }) => `
  font-weight: ${theme.fontWeights.strong};
  border-bottom: ${theme.strokes.small} solid ${theme.colors.dark};
`);

const Clues = ({ abridged, ...restProps }) => {
  const {
    cursor, selectedClues, clueMap,
    clues: { across, down }
  } = useContext(GameContext);

  return abridged ? (
    <List mb="0" {...restProps}>
      {cursor.position !== undefined && (
        <>
          <Item>{cursor.isAcross
            ? clueMap.across[selectedClues.across]
            : clueMap.down[selectedClues.down]
          }</Item>
          <Item>{!cursor.isAcross
            ? clueMap.across[selectedClues.across]
            : clueMap.down[selectedClues.down]
          }</Item>
        </>
      )}
    </List>
  ) : (
    <>
      <Title>Across</Title>
      <List>
        {across.map((clue, i) => (
          <Item key={clue}>{clue} <Answer index={i} across /></Item>
        ))}
      </List>
      <Title>Down</Title>
      <List>
        {down.map((clue, i) => (
          <Item key={clue}>{clue} <Answer index={i} across={false} /></Item>
        ))}
      </List>
    </>
  );
}

export default Clues;
